import {Group} from '@igp/shared/access-control';

export const groups = {
    aalRowGroup: new Group('aal_row'),
    aalRowManagersGroup: new Group('aal_managers_row'),
    adminsGroup: new Group('Admins'),
    aalManagersKrGroup: new Group('aal_managers_kr'),
    aalKrGroup: new Group('aal_kr'),
    countryPartnerGroup: new Group('Country-level Partners'),
    agentManagersGroup: new Group('Agent Managers'),
    agentsGroup: new Group('Agents'),
} as const satisfies Record<string, Group>;
